import { render, staticRenderFns } from "./afteractionReport_add.vue?vue&type=template&id=2781713a&scoped=true&"
import script from "./afteractionReport_add.vue?vue&type=script&lang=js&"
export * from "./afteractionReport_add.vue?vue&type=script&lang=js&"
import style0 from "./afteractionReport_add.vue?vue&type=style&index=0&id=2781713a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2781713a",
  null
  
)

export default component.exports